// extracted by mini-css-extract-plugin
export var centerText = "_ea-8";
export var container = "_ea-0";
export var doughnutContainer = "_ea-7";
export var legend = "_ea-a";
export var legendItemColorDisplay = "_ea-b";
export var legendItemLabel = "_ea-d";
export var legendItemValue = "_ea-c";
export var lg = "_ea-5";
export var maxWidth = "_ea-9";
export var md = "_ea-4";
export var responsive = "_ea-6";
export var sm = "_ea-3";
export var xs = "_ea-2";
export var xxs = "_ea-1";